export default "__VITE_ASSET__BWIBzMJ9__"